<template>
  <div class="join-personal-data">
    <v-row>
      <v-col class="join-personal-data__form-col">
        <h5 class="join-personal-data__form-label">Developer form</h5>

        <JoinForm
          :processing="processing"
          acceptance
          submit-name="JOIN"
          @submit="submitDeveloper"
        />
      </v-col>

      <v-col>
        <h1 class="join-personal-data__title">Apply as a Freelancer</h1>
        <p class="join-personal-data__text">
          Do you have a question? Do you have feedback?<br>
          We look forward to receiving a call or an email from you.
        </p>
        <img class="join-personal-data__img" src="@/assets/img/join.svg" alt="Joins us image" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import JoinForm from '@/components/JoinForm.vue';

export default {
  components: {
    JoinForm,
  },

  props: {
    processing: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    submitDeveloper(developerData) {
      this.$emit('submit', developerData);
    },
  },
};
</script>

<style lang="scss" scoped>
.join-personal-data {
  margin-top: 12px;

  &__form-col {
    padding-right: 0px;

    @include desktop {
      padding-right: 80px;
    }
  }

  &__form-label {
    font-size: 12px;
    font-weight: 600;
    padding-bottom: 8px;
    margin-bottom: 16px;
    border-bottom: 1px solid #E2E6EA;

  }

  &__title {
    font-size: 28px;
    margin-bottom: 12px;
    color: $main--text;
  }

  &__text {
    line-height: 28px;
    margin-bottom: 20px;
    color: $main--text;
    opacity: 0.7;
    @include desktop {
      margin-bottom: 100px;
    }
  }

  &__img {
    max-width: 100%;
  }
}
</style>
